<template>
    <div class="titulo">
        <div class="margem container">
            <h2>Gestão de Mudanças</h2>
        </div>
    </div>

    <div class="margem container">
        <div v-if="loading" class="loading">
            <div></div>
        </div>

        <p v-else-if="todosCards.length === 0" class="alinha-centro">
            <span class="chip bg-cinza vazio">Nenhuma solicitação pendente no momento.</span>
        </p>

        <template v-else>
            <div class="tags filtros-tipo m-b">
                <a v-for="f in filtrosTipo" :key="f.id" href="#" class="filtro-tipo"
                    :class="{ ativo: filtroTipo === f.id }" @click.prevent="filtroTipo = f.id">
                    <!-- <span class="filtro-tipo-icone" aria-hidden="true">{{ f.icone }}</span> -->
                    <span>{{ f.nome }}</span>
                    <span v-if="f.contagem > 0" class="hPoints bg-cinza fonte-menor">{{ f.contagem }}</span>
                </a>
            </div>

            <p v-if="cardsFiltrados.length === 0" class="alinha-centro">
                <span class="chip bg-cinza vazio">Nenhuma solicitação neste filtro.</span>
            </p>

            <ul v-else class="lista-cards">
            <li v-for="card in cardsFiltrados" :key="card.key" class="card-pendencia bloco2 margem"
                :class="[card.classeTipo, { 'card-pendencia--clicavel': !!card.projetoId }]">
                <div class="card-area-clique" role="button" tabindex="0"
                    :title="card.projetoId ? 'Clique para abrir o projeto' : undefined"
                    @click="abrirProjetoDoCard(card)" @keydown.enter="abrirProjetoDoCard(card)">
                    <div class="card-faixa-tipo">
                        <span class="card-tipo-icone" aria-hidden="true">{{ card.iconeTipo }}</span>
                        <span class="card-tipo-label">{{ card.tipoLabel }}</span>
                        <span v-if="card.data" class="card-data">{{ formatarDataBr(card.data) }}</span>
                    </div>

                    <h3 class="card-titulo"><span v-if="card.pcmCodigo">{{ card.pcmCodigo }} - </span>{{
                        card.projetoNome }}</h3>

                    <div v-if="card.tipo === 'mudanca'" class="card-comparacao">
                        <p class="comparacao-campo">{{ card.campoLabel }}</p>
                        <div class="comparacao-grid">
                            <div class="comparacao-col comparacao-col--antigo">
                                <span class="comparacao-titulo">Valor atual</span>
                                <pre class="comparacao-valor">{{ card.valorAntigo }}</pre>
                            </div>
                            <div class="comparacao-seta" aria-hidden="true">→</div>
                            <div class="comparacao-col comparacao-col--novo">
                                <span class="comparacao-titulo">Novo valor</span>
                                <pre class="comparacao-valor">{{ card.valorNovo }}</pre>
                            </div>
                        </div>
                        <dl class="card-detalhes card-detalhes--inline">
                            <dt>Solicitante</dt>
                            <dd>{{ card.solicitante }}</dd>
                            <dt>Justificativa</dt>
                            <dd>{{ card.justificativa }}</dd>
                        </dl>
                    </div>

                    <div v-else class="card-campos-grid">
                        <div v-for="(d, i) in card.detalhes" :key="i" class="campo-bloco"
                            :class="{ 'campo-bloco--wide': d.wide }">
                            <span class="campo-label">{{ d.label }}</span>
                            <span class="campo-valor">{{ d.valor }}</span>
                        </div>
                    </div>
                </div>

                <div class="card-acoes" @click.stop>
                    <div v-if="card.tipo === 'mudanca'" class="card-parecer">
                        <label :for="`obs-${card.raw.id}`">Parecer do aprovador (opcional)</label>
                        <textarea :id="`obs-${card.raw.id}`" v-model="obsPorPedido[card.raw.id]" rows="2"
                            placeholder="Registre observações ao aprovar ou reprovar"></textarea>
                    </div>

                    <div class="card-rodape">
                        <div class="submit">
                            <button v-if="card.pcmId" class="acao-secundaria btn-historico-mudancas"
                                title="Ver histórico de pedidos de mudança do projeto"
                                @click="abrirHistoricoPedidos(card)">
                                <i class="bi bi-clock-history" aria-hidden="true"></i>
                                Histórico de mudanças
                            </button>
                            <button type="button" class="acao-secundaria reprovar"
                                :disabled="processando === card.processandoId"
                                @click="reprovarCard(card)">Reprovar</button>
                            <button type="button" class="acao-secundaria aprovar"
                                :disabled="processando === card.processandoId" @click="aprovarCard(card)">{{
                                    card.labelAprovar }}</button>
                        </div>
                    </div>
                </div>
            </li>
            </ul>
        </template>
    </div>

    <ModalHistoricoPedidosMudanca :mostrar="!!modalHistoricoPedidos" :pcm-id="modalHistoricoPedidos?.pcmId"
        :titulo-projeto="modalHistoricoPedidos?.projetoNome || ''"
        :pcm-codigo="modalHistoricoPedidos?.pcmCodigo || ''" @fechar="modalHistoricoPedidos = null" />
</template>

<script>
import servicePCM from '@/services/servicePCM'
import serviceProjetos from '@/services/serviceProjetos'
import { formatarDataBr, dataParaInput } from '@/utils/date'
import ModalHistoricoPedidosMudanca from '@/components/Gestão/ModalHistoricoPedidosMudanca.vue'

export default {
    name: 'GestaoDeMudanca',

    components: {
        ModalHistoricoPedidosMudanca,
    },

    data() {
        return {
            loading: true,
            processando: null,
            pedidosMudanca: [],
            pedidosEncerramento: [],
            pcmsPendentes: [],
            obsPorPedido: {},
            campos: servicePCM.campos,
            filtroTipo: 'todos',
            modalHistoricoPedidos: null,
        }
    },

    computed: {
        totalPendentes() {
            return this.pedidosMudanca.length + this.pedidosEncerramento.length + this.pcmsPendentes.length
        },

        filtrosTipo() {
            return [
                { id: 'todos', nome: 'Todos', icone: '≡', contagem: this.totalPendentes },
                { id: 'encerramento', nome: 'Pedidos de encerramento', icone: '✓', contagem: this.pedidosEncerramento.length },
                { id: 'mudanca', nome: 'Pedidos de mudança', icone: '✎', contagem: this.pedidosMudanca.length },
                { id: 'aprovacao', nome: 'Aprovações de projeto', icone: '◎', contagem: this.pcmsPendentes.length },
            ]
        },

        /** Código PCM por projeto_id (união de todas as fontes carregadas) */
        mapaPcmCodigoPorProjeto() {
            const map = {}
            const registrar = (projetoId, codigo) => {
                if (projetoId && codigo) map[projetoId] = codigo
            }
            this.pedidosMudanca.forEach((p) => registrar(p.projeto_id, p.pcm?.codigo))
            this.pedidosEncerramento.forEach((e) => registrar(e.projeto_id, e.pcm_codigo))
            this.pcmsPendentes.forEach((pcm) => registrar(this.projetoIdDoPcm(pcm), pcm.codigo))
            return map
        },

        /** PCM id por projeto_id (para histórico de pedidos de mudança) */
        mapaPcmIdPorProjeto() {
            const map = {}
            const registrar = (projetoId, pcmId) => {
                if (projetoId && pcmId) map[projetoId] = pcmId
            }
            this.pedidosMudanca.forEach((p) => registrar(p.projeto_id, p.pcm_id))
            this.pedidosEncerramento.forEach((e) => registrar(e.projeto_id, e.pcm_id))
            this.pcmsPendentes.forEach((pcm) => registrar(this.projetoIdDoPcm(pcm), pcm.id))
            return map
        },

        todosCards() {
            const lista = []
            const codigos = this.mapaPcmCodigoPorProjeto
            const pcmIds = this.mapaPcmIdPorProjeto

            for (const p of this.pedidosMudanca) {
                const resumo = this.resumoValoresPedido(p)
                lista.push({
                    key: `mudanca-${p.id}`,
                    tipo: 'mudanca',
                    tipoLabel: 'Pedido de mudança',
                    iconeTipo: '✎',
                    classeTipo: 'card-pendencia--mudanca',
                    projetoId: p.projeto_id,
                    projetoNome: p.projeto_nome || 'Projeto sem nome',
                    pcmCodigo: p.pcm?.codigo ?? codigos[p.projeto_id] ?? null,
                    pcmId: p.pcm_id ?? pcmIds[p.projeto_id] ?? null,
                    abaProjeto: 2,
                    data: p.created_at,
                    dataOrdenacao: this.timestamp(p.created_at),
                    campoLabel: this.labelCampoPedido(p),
                    valorAntigo: resumo.valorAntigo,
                    valorNovo: resumo.valorNovo,
                    solicitante: p.solicitante?.name || '—',
                    justificativa: p.justificativa || '—',
                    processandoId: p.id,
                    labelAprovar: 'Aprovar',
                    raw: p,
                })
            }

            for (const e of this.pedidosEncerramento) {
                const cancelamento = e.tipo === 'cancelamento'
                lista.push({
                    key: `encerramento-${e.projeto_id}`,
                    tipo: 'encerramento',
                    tipoLabel: cancelamento ? 'Pedido de cancelamento' : 'Pedido de conclusão',
                    iconeTipo: cancelamento ? '✕' : '✓',
                    classeTipo: cancelamento ? 'card-pendencia--cancelamento' : 'card-pendencia--conclusao',
                    projetoId: e.projeto_id,
                    projetoNome: e.projeto_nome || 'Projeto sem nome',
                    pcmCodigo: e.pcm_codigo ?? codigos[e.projeto_id] ?? null,
                    pcmId: e.pcm_id ?? pcmIds[e.projeto_id] ?? null,
                    abaProjeto: 5,
                    data: e.created_at,
                    dataOrdenacao: this.timestamp(e.created_at),
                    detalhes: this.detalhesEncerramento(e),
                    processandoId: e.projeto_id,
                    labelAprovar: cancelamento ? 'Aprovar' : 'Aprovar',
                    raw: e,
                })
            }

            for (const pcm of this.pcmsPendentes) {
                const projetoId = this.projetoIdDoPcm(pcm)
                lista.push({
                    key: `aprovacao-${pcm.id}`,
                    tipo: 'aprovacao',
                    tipoLabel: 'Aprovação de projeto',
                    iconeTipo: '◎',
                    classeTipo: 'card-pendencia--aprovacao',
                    projetoId,
                    projetoNome: pcm.nome_associacao || pcm.nome || 'Projeto sem nome',
                    pcmCodigo: pcm.codigo ?? codigos[projetoId] ?? null,
                    pcmId: pcm.id ?? null,
                    abaProjeto: 2,
                    data: pcm.created_at ?? pcm.dtCadastro,
                    dataOrdenacao: this.timestamp(pcm.created_at ?? pcm.dtCadastro),
                    detalhes: [
                        { label: 'Nível', valor: pcm.nivel || '—', wide: false },
                        { label: 'Gerente', valor: pcm.gerentePCM_nome || '—', wide: false },
                    ],
                    processandoId: pcm.id,
                    labelAprovar: 'Aprovar',
                    raw: pcm,
                })
            }

            return lista.sort((a, b) => a.dataOrdenacao - b.dataOrdenacao)
        },

        cardsFiltrados() {
            if (this.filtroTipo === 'todos') return this.todosCards
            return this.todosCards.filter((c) => c.tipo === this.filtroTipo)
        },
    },

    async mounted() {
        await this.carregarDados()
    },

    methods: {
        formatarDataBr,

        abrirProjetoDoCard(card) {
            if (!card.projetoId) return
            this.abrirProjeto(card.projetoId, card.abaProjeto)
        },

        abrirHistoricoPedidos(card) {
            if (!card.pcmId) return
            this.modalHistoricoPedidos = {
                pcmId: card.pcmId,
                projetoNome: card.projetoNome,
                pcmCodigo: card.pcmCodigo,
            }
        },

        timestamp(valor) {
            if (!valor) return 0
            const t = Date.parse(String(valor).slice(0, 10))
            return Number.isNaN(t) ? 0 : t
        },

        labelCampo(campo) {
            return servicePCM.labelCampoPedido(campo) || this.campos[campo]?.label || campo
        },

        labelCampoPedido(pedido) {
            return servicePCM.labelCampoPedidoCompleto(pedido)
                || this.campos[pedido?.campo]?.label
                || pedido?.campo
        },

        textoParaResumo(valor) {
            const t = (valor ?? '').toString()
            return t.trim() === '' ? '(vazio)' : t
        },

        textoOpcional(valor) {
            const t = (valor ?? '').toString().trim()
            return t === '' ? '(não informado)' : t
        },

        detalhesEncerramento(e) {
            const cancelamento = e.tipo === 'cancelamento'
            const dataPedido = formatarDataBr(e.created_at || e.dtConclusao)

            if (cancelamento) {
                return [
                    { label: 'Data do cancelamento', valor: dataPedido, wide: false },
                    { label: 'Motivo do cancelamento', valor: this.textoParaResumo(e.conclusao), wide: true },
                    { label: 'Observações complementares (opcional)', valor: this.textoOpcional(e.evidenciaAlcance), wide: true },
                ]
            }

            return [
                { label: 'Data de término do projeto', valor: dataPedido, wide: false },
                { label: 'Custo previsto', valor: this.custoParaResumo(e.custoEstimado), wide: false },
                { label: 'Custo Real', valor: this.custoParaResumo(e.custoReal), wide: false },
                { label: 'Evidências de alcance', valor: this.textoParaResumo(e.evidenciaAlcance), wide: true },
                { label: 'Observação', valor: this.textoOpcional(e.escopoAlcancado), wide: true },
            ]
        },

        normalizarCusto(valor) {
            if (valor === '' || valor == null) return null
            const n = Number(valor)
            return Number.isFinite(n) ? n : null
        },

        custoParaResumo(valor) {
            const n = this.normalizarCusto(valor)
            if (n == null) return '(vazio)'
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
        },

        formatarValorCampo(pedido, qual) {
            const campo = pedido.campo
            const parsed = servicePCM.parseCampoPedidoResultado(campo)
            const meta = servicePCM.metaCampoPedido(campo) || this.campos[campo]
            let valor = qual === 'atual' ? pedido.valor_atual : pedido.novo_valor

            if (parsed?.tipo === 'lista' || campo === 'resultados') {
                return qual === 'atual'
                    ? this.resumoPedidoResultados(pedido).valorAntigo
                    : this.resumoPedidoResultados(pedido).novoValor
            }

            if (parsed && parsed.tipo !== 'lista') {
                return servicePCM.formatarValorPedidoResultado(pedido, qual)
            }

            if (campo === 'objetivos_estrategicos') {
                return qual === 'atual'
                    ? this.resumoPedidoObjetivos(pedido).valorAntigo
                    : this.resumoPedidoObjetivos(pedido).novoValor
            }

            if (meta?.tipo === 'moeda' || campo === 'estimativa_custo') {
                if (valor != null && valor !== '') {
                    const n = parseFloat(valor)
                    if (!Number.isNaN(n)) {
                        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
                    }
                }
                return this.custoParaResumo(valor)
            }

            if (meta?.tipo === 'date' && valor) {
                return formatarDataBr(String(valor).slice(0, 10))
            }

            return this.textoParaResumo(valor)
        },

        resumoValoresPedido(pedido) {
            return {
                valorAntigo: this.formatarValorCampo(pedido, 'atual'),
                valorNovo: this.formatarValorCampo(pedido, 'novo'),
            }
        },

        parseResultadosPedido(valor) {
            if (!valor) return []
            try {
                const parsed = JSON.parse(valor)
                return Array.isArray(parsed) ? parsed : []
            } catch {
                return []
            }
        },

        parseObjetivosPedido(valor) {
            if (!valor) return []
            try {
                const parsed = JSON.parse(valor)
                return Array.isArray(parsed) ? parsed : []
            } catch {
                return []
            }
        },

        resumoPedidoObjetivos(pedido) {
            const anterior = this.parseObjetivosPedido(pedido?.valor_atual)
            const proposto = this.parseObjetivosPedido(pedido?.novo_valor)
            const formatarLista = (lista) => {
                if (!lista.length) return '(nenhum objetivo selecionado)'
                return lista.map((item) => `- ${item.nome || `Objetivo #${item.objetivo_id ?? '?'}`}`).join('\n')
            }
            return {
                valorAntigo: formatarLista(anterior),
                novoValor: formatarLista(proposto),
            }
        },

        normalizarTexto(valor) {
            return (valor ?? '').toString().trim()
        },

        resumoItemCompleto(item, rotulo) {
            return servicePCM.resumoItemResultadoCompleto(item, rotulo)
        },

        resumoPedidoResultados(pedido) {
            const anterior = this.parseResultadosPedido(pedido?.valor_atual)
            const proposto = this.parseResultadosPedido(pedido?.novo_valor)

            const porIdAnterior = new Map(
                anterior.filter((i) => i?.id != null).map((i) => [String(i.id), i])
            )
            const porIdProposto = new Map(
                proposto.filter((i) => i?.id != null).map((i) => [String(i.id), i])
            )

            const blocosAntigo = [`Total: ${anterior.length} item(ns)`]
            const blocosNovo = [`Total: ${proposto.length} item(ns)`]

            proposto.forEach((itemNovo, idx) => {
                const n = idx + 1
                if (itemNovo?.id == null) {
                    blocosAntigo.push(`Item ${n}: (novo — não existia)`)
                    blocosNovo.push(this.resumoItemCompleto(itemNovo, `Item ${n} (novo)`))
                    return
                }
                const itemAntigo = porIdAnterior.get(String(itemNovo.id))
                if (!itemAntigo) {
                    blocosAntigo.push(`Item ${n}: não existia`)
                    blocosNovo.push(this.resumoItemCompleto(itemNovo, `Item ${n}`))
                    return
                }
                const mudou =
                    this.normalizarTexto(itemAntigo.descricao) !== this.normalizarTexto(itemNovo.descricao) ||
                    !!itemAntigo.sem_custo !== !!itemNovo.sem_custo ||
                    this.normalizarCusto(itemAntigo.custo) !== this.normalizarCusto(itemNovo.custo)
                if (mudou) {
                    const custoAnt = itemAntigo.sem_custo
                        ? 'sem custo'
                        : this.custoParaResumo(itemAntigo.custo)
                    const custoNovo = itemNovo.sem_custo
                        ? 'sem custo'
                        : this.custoParaResumo(itemNovo.custo)
                    blocosAntigo.push(
                        `Item ${n}:\n  ${this.textoParaResumo(itemAntigo.descricao)}\n  Custo: ${custoAnt}`
                    )
                    blocosNovo.push(
                        `Item ${n}:\n  ${this.textoParaResumo(itemNovo.descricao)}\n  Custo: ${custoNovo}`
                    )
                }
            })

            anterior.forEach((itemAntigo, idx) => {
                if (itemAntigo?.id == null || porIdProposto.has(String(itemAntigo.id))) return
                blocosAntigo.push(this.resumoItemCompleto(itemAntigo, `Item ${idx + 1} (removido)`))
                blocosNovo.push(`Item ${idx + 1}: removido na proposta`)
            })

            return {
                valorAntigo: blocosAntigo.join('\n\n') || '—',
                novoValor: blocosNovo.join('\n\n') || '—',
            }
        },

        projetoIdDoPcm(pcm) {
            if (pcm.projeto !== 1 && pcm.projeto !== '1') return null
            return pcm.associadao_id || pcm.associacao_id || null
        },

        abrirProjeto(projetoId, aba = null) {
            if (!projetoId) return
            const query = aba ? { aba: String(aba) } : {}
            this.$router.push({ name: 'projetoView', params: { idProjeto: projetoId }, query })
        },

        async carregarDados() {
            this.loading = true
            try {
                const [pedidos, encerramentos, pcms] = await Promise.all([
                    servicePCM.listarPedidosEdicao('pendente'),
                    serviceProjetos.getEncerramentos(true).catch(() => []),
                    servicePCM.listarPCMs({
                        status: 'Aguardando Aprovação',
                        apenas_projeto: 1,
                    }),
                ])

                this.pedidosMudanca = Array.isArray(pedidos) ? pedidos : []
                this.pedidosEncerramento = Array.isArray(encerramentos) ? encerramentos : []
                this.pcmsPendentes = Array.isArray(pcms) ? pcms : []
            } finally {
                this.loading = false
            }
        },

        async aprovarCard(card) {
            if (card.tipo === 'mudanca') {
                await this.aprovarPedidoMudanca(card.raw.id, 'aprovado')
            } else if (card.tipo === 'encerramento') {
                await this.aprovarEncerramento(card.raw.projeto_id, 'Aprovado')
            } else {
                await this.aprovarPcm(card.raw, 'Aprovado')
            }
        },

        async reprovarCard(card) {
            if (card.tipo === 'mudanca') {
                await this.aprovarPedidoMudanca(card.raw.id, 'reprovado')
            } else if (card.tipo === 'encerramento') {
                await this.aprovarEncerramento(card.raw.projeto_id, 'Reprovado')
            } else {
                await this.aprovarPcm(card.raw, 'Reprovado')
            }
        },

        async aprovarPedidoMudanca(id, status) {
            this.processando = id
            try {
                const obs = this.obsPorPedido[id] ?? null
                await servicePCM.aprovarPedidoEdicao(id, status, obs)
                delete this.obsPorPedido[id]
                await this.carregarDados()
            } finally {
                this.processando = null
            }
        },

        async aprovarEncerramento(projetoId, status) {
            this.processando = projetoId
            try {
                await serviceProjetos.aprovarEncerramento(projetoId, status)
                await this.carregarDados()
            } finally {
                this.processando = null
            }
        },

        async aprovarPcm(pcm, status) {
            this.processando = pcm.id
            try {
                const hoje = dataParaInput(new Date().toISOString())
                await servicePCM.atualizarPCM('dtAprovacao', hoje, pcm.id)
                await servicePCM.atualizarPCM('status', status, pcm.id)

                const projetoId = this.projetoIdDoPcm(pcm)
                if (projetoId) {
                    const novoStatus = status === 'Aprovado' ? 'Em andamento' : 'Reprovado'
                    await serviceProjetos.atualizarProjeto(projetoId, { status: novoStatus })
                }
                await this.carregarDados()
            } finally {
                this.processando = null
            }
        },
    },
}
</script>

<style scoped>
.aprovar {
    background-color: var(--cor-sucesso);
    color: var(--cor-bg);
}

.reprovar {
    background-color: var(--cor-erro);
    color: var(--cor-bg);
}

.subtitulo-gestao {
    margin: 0.35rem 0 0;
    opacity: 0.75;
    font-size: 0.95rem;
}

.filtros-tipo {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.filtro-tipo {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 0.85rem;
    border-radius: 6px;
    text-decoration: none;
    color: inherit;
    font-size: 0.9rem;
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.12));
    background: var(--cor-cinza, rgba(0, 0, 0, 0.04));
    transition: background 0.15s ease, border-color 0.15s ease;
}

.filtro-tipo:hover {
    background: var(--cor-cinza2, rgba(0, 0, 0, 0.07));
}

.filtro-tipo.ativo {
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12));
    border-color: var(--cor-primaria, #00b6b3);
    font-weight: 600;
}

.filtro-tipo-icone {
    font-size: 0.85rem;
    line-height: 1;
}

.lista-cards {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.card-pendencia {
    padding: 0;
    overflow: hidden;
    border-left: 4px solid transparent;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.card-pendencia--clicavel .card-area-clique {
    cursor: pointer;
}

.card-pendencia--clicavel .card-area-clique:hover {
    filter: brightness(0.98);
}

.card-pendencia--mudanca {
    border-left-color: var(--cor-primaria, #00b6b3);
    background: linear-gradient(135deg, var(--cor-primaria-fraca, rgba(0, 182, 179, 0.08)) 0%, var(--cor-bg, #fff) 55%);
}

.card-pendencia--conclusao {
    border-left-color: var(--cor-sucesso, #2e7d32);
    background: linear-gradient(135deg, hsl(130 40% 94%) 0%, var(--cor-bg, #fff) 55%);
}

.card-pendencia--cancelamento {
    border-left-color: var(--cor-erro, #c62828);
    background: linear-gradient(135deg, hsl(0 60% 96%) 0%, var(--cor-bg, #fff) 55%);
}

.card-pendencia--aprovacao {
    border-left-color: hsl(220 50% 45%);
    background: linear-gradient(135deg, hsl(220 40% 95%) 0%, var(--cor-bg, #fff) 55%);
}

.card-area-clique {
    padding: 1.1rem 1.25rem 0.85rem;
}

.card-faixa-tipo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.65rem;
    flex-wrap: wrap;
}

.btn-historico-mudancas {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.45rem 0.75rem !important;
    border-radius: 8px !important;
    font-size: 0.88rem;
    font-weight: 600;
    flex-shrink: 0;
    border: none;
}

.btn-historico-mudancas:hover {
    color: var(--cor-primaria, #00b6b3) !important;
    /* border-color: var(--cor-primaria, #00b6b3) !important; */
    /* background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12)) !important; */
}

.card-tipo-icone {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    font-size: 0.85rem;
    font-weight: 700;
    background: rgba(0, 0, 0, 0.06);
}

.card-pendencia--mudanca .card-tipo-icone {
    background: var(--cor-primaria-media, rgba(0, 182, 179, 0.2));
    color: var(--cor-primaria-forte, #008a88);
}

.card-pendencia--conclusao .card-tipo-icone {
    background: hsl(130 40% 85%);
    color: var(--cor-sucesso, #2e7d32);
}

.card-pendencia--cancelamento .card-tipo-icone {
    background: hsl(0 50% 90%);
    color: var(--cor-erro, #c62828);
}

.card-pendencia--aprovacao .card-tipo-icone {
    background: hsl(220 40% 88%);
    color: hsl(220 50% 35%);
}

.card-tipo-label {
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    flex: 1;
}

.card-pendencia--mudanca .card-tipo-label {
    color: var(--cor-primaria-forte, #008a88);
}

.card-pendencia--conclusao .card-tipo-label {
    color: var(--cor-sucesso, #2e7d32);
}

.card-pendencia--cancelamento .card-tipo-label {
    color: var(--cor-erro, #c62828);
}

.card-pendencia--aprovacao .card-tipo-label {
    color: hsl(220 50% 35%);
}

.card-data {
    font-size: 0.85rem;
    opacity: 0.65;
}

.card-titulo {
    margin: 0 0 0.25rem;
    font-size: 1.2rem;
    line-height: 1.3;
    color: var(--cor-fonte-forte, inherit);
}

.card-meta {
    margin: 0 0 0.75rem;
    font-size: 0.88rem;
    opacity: 0.7;
}

.card-comparacao {
    margin-top: 0.25rem;
}

.comparacao-campo {
    margin: 0 0 0.5rem;
    font-weight: 600;
    font-size: 0.95rem;
}

.comparacao-grid {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 0.65rem;
    align-items: stretch;
}

@media (max-width: 640px) {
    .comparacao-grid {
        grid-template-columns: 1fr;
    }

    .comparacao-seta {
        transform: rotate(90deg);
        justify-self: center;
    }
}

.comparacao-col {
    border-radius: 6px;
    padding: 0.65rem 0.75rem;
    min-width: 0;
}

.comparacao-col--antigo {
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.comparacao-col--novo {
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.1));
    border: 1px solid var(--cor-primaria-media, rgba(0, 182, 179, 0.25));
}

.comparacao-titulo {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.7;
    margin-bottom: 0.35rem;
}

.comparacao-valor {
    margin: 0;
    font-family: inherit;
    font-size: 0.88rem;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
}

.comparacao-seta {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    opacity: 0.45;
    padding-top: 1.2rem;
}

.card-campos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
    margin-top: 0.25rem;
}

@media (max-width: 900px) {
    .card-campos-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 520px) {
    .card-campos-grid {
        grid-template-columns: 1fr;
    }
}

.campo-bloco {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.65rem 0.75rem;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.55);
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.08));
    min-width: 0;
}

.campo-bloco--wide {
    grid-column: 1 / -1;
}

.campo-label {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.7;
}

.campo-valor {
    font-size: 0.92rem;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
}

.card-detalhes {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.35rem 1rem;
    margin: 0.5rem 0 0;
    font-size: 0.92rem;
}

.card-detalhes--inline {
    margin-top: 0.85rem;
    padding-top: 0.75rem;
    border-top: 1px dashed var(--cor-separador, rgba(0, 0, 0, 0.12));
}

.card-detalhes dt {
    margin: 0;
    font-weight: 600;
    opacity: 0.8;
}

.card-detalhes dd {
    margin: 0;
    white-space: pre-wrap;
}

.card-acoes {
    padding: 0 1.25rem 1.1rem;
    background: rgba(0, 0, 0, 0.02);
    border-top: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.1));
}

.card-parecer {
    padding-top: 0.85rem;
}

.card-parecer label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 0.88rem;
}

.card-parecer textarea {
    width: 100%;
    font-size: 0.9rem;
}

.card-rodape {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding-top: 0.75rem;
}

.card-rodape .submit {
    margin-left: auto;
}

.submit {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.vazio {
    display: inline-block;
    margin: 2rem auto;
    padding: 0.75rem 1.25rem;
}
</style>
